import React from 'react';
import {authRole} from '../../shared/constants/AppConst';

export const authRouteConfig = [
  {
    routes: [
      {
        path: '/signin',
        component: React.lazy(() => import('./Signin')),
      },
    ],
  },
  {
    auth: authRole.user,
    routes: [
      {
        path: '/myaccount',
        component: React.lazy(() => import('./MyAccount')),
      },
    ],
  },
  {
    routes: [
      {
        path: '/signup',
        component: React.lazy(() => import('./Signup')),
      },
    ],
  },
  {
    routes: [
      {
        path: '/verifyemail',
        component: React.lazy(() => import('./VerifyEmail')),
      },
    ],
  },
  {
    routes: [
      {
        path: '/forgot-password',
        component: React.lazy(() => import('./ForgetPassword')),
      },
    ],
  },
  {
    routes: [
      {
        path: '/error-pages/error-404',
        component: React.lazy(() => import('../errorPages/Error404/index')),
      },
    ],
  },
];